module.exports = __webpack_public_path__ + "static/media/familia4.c1389d7a.jpg";